import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/types';
import { OPS_COUNTRY_TO_REGION, OPS_REGIONAL_CLAIM_TEMPLATE_CONFIG_MAP } from '../types';

export const usePreFilledPromotionalClaimGenerator = () => {
    const selectedReseller = useSelector((state: RootState) => state.resellerReducer.selectedReseller.value);

    const isPreFilledClaimGeneratorEnabled = useMemo(() => {
        const isResellerEnabled = () => {
            if (!selectedReseller) return false;
            const { countryCode, resellerId } = selectedReseller;

            if (!countryCode || !(countryCode in OPS_COUNTRY_TO_REGION)) return false;

            const region = OPS_COUNTRY_TO_REGION[countryCode as keyof typeof OPS_COUNTRY_TO_REGION];
            const config =
                OPS_REGIONAL_CLAIM_TEMPLATE_CONFIG_MAP[region as keyof typeof OPS_REGIONAL_CLAIM_TEMPLATE_CONFIG_MAP];
            const resellerInBlockList = config.resellerIdBlockList.includes(resellerId as string);
            const resellerInAllowList = config.countryCodeAllowList.includes(countryCode);

            return config.enableRegion && !resellerInBlockList && resellerInAllowList;
        };

        return isResellerEnabled();
    }, [selectedReseller]);

    return {
        isPreFilledClaimGeneratorEnabled,
    };
};
